<template>
  <div>
    <v-btn :small="small" type="button" v-on:click="onexport">Excel download</v-btn>
  </div>
</template>

<script>
import XLSX from 'xlsx'
import constants from '@/data/constants'
export default {
  props: ['data', 'name', 'fileName', 'columns', 'small'],
  data: () => ({
    constants: constants
  }),
  // async created () {
  //   this.Datas = await api.getDatas()
  // },
  methods: {
    humanize (str) {
      var frags = str.split('_')
      for (var i = 0; i < frags.length; i++) {
        frags[i] = frags[i].charAt(0).toUpperCase() + frags[i].slice(1)
      }
      return frags.join(' ')
    },
    get_visa_status (packing) {
      var vss = constants.VISA_STATUSES.filter(
        vs => vs.id == (!packing.visa_status ? this.data.visa_status : packing.visa_status)
      )
      if (vss[0] != undefined) {
        return vss[0].id > 0 ? vss[0].name : ''
      } else {
        return ''
      }
    },
    format_date (date) {
      var moment = require('moment')
      var ndate = new Date(date)
      return moment(ndate).format('YYYY-MM-DD')
    },
    onexport () {
        // console.log('exhibitions')
      var col = ['id', 'title'].concat(this.columns)
      var settings = {
        // skipHeader: true,
        origin: 'A2'
      }
      var artist = this.$store.state.artists.find(
        a => a.id === this.data.artist.id
      )
      let transformedData = this.data.artwork_packings.map(textRow => {
        // var todos = Object.assign([], this.$store.state.todos.filter(t => { return textRow.id == t.artwork_id}))
        // tod os = todos.map(a => {return a.title})
        // var packings = data.artwork_packings
        // packings = packings.map(a => {return a.colli})
        // var exhibitions = Object.assign([], this.$store.state.exhibitions.filter(t => {
        //   return t.artworks.map(a => a = a.id ).includes(textRow.id)
        // }))
        // exhibitions = exhibitions.map(a => {return a.title})

        // ARTWORK DIMENSIONS
        var arr = [this.data.dim_length, this.data.dim_width, this.data.dim_height, this.data.dim_depth]
        var dim = arr.filter(a => a != null && a != '').join(' x ')
        dim = dim ? dim + ' cm ' : null
        var dimensions = dim + (this.data.dim_diameter ? 'ø' + this.data.dim_diameter : '')

        return {
          // Accession Number, Artist Full Name, Title, Year, Medium, Dimensions
          Artist: artist.name ? artist.name : '',
          Title:
            this.data.title +
            ', ' +
            (this.data.production_date ? this.data.production_date_new : ''),
          'Accession Number': this.data.accession_number
            ? this.data.accession_number
            : '',
          'Production Date': this.data.production_date_new
            ? this.data.production_date_new
            : '',
          'Visa Status': this.get_visa_status(textRow),
          Colli: textRow.colli,
          Packing: textRow.packing,
          Height: textRow.height,
          Length: textRow.lenght,
          Width: textRow.width,
          Weigth: textRow.weight,
          // Depth: textRow.depth,
          Location: textRow.artwork_location_id ? this.$store.state.locations.find(l => l.id === textRow.artwork_location_id).name : '',
          'Media Material Description': this.data.media_material_description,
          'Artwork Dimensions (cm)': dimensions,
          // 'Artwork Heigth (cm)': this.data.dim_height,
          // 'Artwork Depth (cm)': this.data.dim_depth,
          // 'Artwork Diameter (cm)': this.data.dim_diameter,
          Contents: textRow.contents,
          Note: textRow.note
          // "classification": (textRow.classification ? textRow.classification.toUpperCase() : ''),
          // "todos": todos.length > 0 ? ('ToDos: ' + (todos.join(', '))) : '',
          // "exhibitions": exhibitions.length > 0 ? ('Exhibitions: \n >> ' + (exhibitions.join('\n >> '))) : '',
          // "packings": packings.length > 0 ? (packings) : ''
        }
      })
      var sheet = XLSX.utils.json_to_sheet(transformedData, settings)
      var wb = XLSX.utils.book_new() // make Workbook of Excel
      XLSX.utils.book_append_sheet(wb, sheet, this.name)
      XLSX.writeFile(wb, this.fileName + '.xlsx') // name of the file is 'book.xlsx'

      // export Excel file
      // add Worksheet to Workbook
      // Workbook contains one or more worksheets
      // XLSX.utils.book_append_sheet(wb, animalWS, 'animals')
      // sheetAName is name of Worksheet
      // var sheet = XLSX.utils.json_to_sheet(this.data)
      // A workbook is the name given to an Excel file
    }
  }
}
</script>

<style scoped>
</style>


// WEBPACK FOOTER //
// src/components/artworks/ExcelPackings.vue